export default __webpack_public_path__ + "static/media/kitchen5-afterB-480w.7dcd05a5.webp";